<template>
  <div>
    <Dialog v-model:visible="visible" modal :closable="false" :header="title" :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <div class="flex flex-col">
        <label class="block text-sm font-medium leading-6 text-gray-900">Voice Bot</label>
        <label class="text-sm mb-1">Select a Bot to handle Voice</label>
        <div class="flex items-center">
          <Dropdown v-model="numberCopy.voiceBotId" :options="botsStore.bots" filter optionLabel="name" optionValue="id" placeholder="Select a Bot" class="w-full md:w-14rem"></Dropdown>
          <Button v-tooltip.top="'Clear'" icon="pi pi-times" @click="numberCopy.voiceBotId = null" severity="secondary" class="ml-2" />
        </div>
        <!-- TODO Enable when SMS Phone numbers are available
        <label class="block text-sm font-medium leading-6 text-gray-900 mt-2">SMS Bot</label>
        <label class="text-sm mb-1">Select a Bot to handle SMS</label>
        <div class="flex items-center">
          <Dropdown v-model="numberCopy.smsBotId" :options="botsStore.bots" filter optionLabel="name" optionValue="id" placeholder="Select a Bot" class="w-full md:w-14rem"></Dropdown>
          <Button v-tooltip.top="'Clear'" icon="pi pi-times" @click="numberCopy.smsBotId = null" severity="secondary" class="ml-2" />
        </div>
        -->
        <StdPropEditor class="w-full mt-4" :prop-def="propsDefs['handoffNumber']" v-model="numberCopy.handoffNumber" />
        <!--
        <StdPropEditor class="col-span-4" :prop-def="propsDefs['handoffNumber']" v-model="numberCopy.handoffNumber" />
        <BotSelector v-model="numberCopy.voiceBotId" :label="propsDefs['voiceBotId'].title" :description="propsDefs['voiceBotId'].description"></BotSelector>
        <label class="text-sm mt-4">Description</label>
        <StdPropEditor class="col-span-4" :prop-def="categoryPropDefs['description']" v-model="categoryCopy.description" />
        <label class="text-sm mt-4">KPIs</label>
        <label class="text-xs mt-1 mb-2">Only analyze selected KPIs for this Category and child categories. Keep blank to analyze all. </label>
        <StdItemMultiSelect v-model="categoryCopy.kpis" :availableItems="categoriesStore.catKpis" :disableAddItem="true"></StdItemMultiSelect>
        <label>TODO Tags</label>
        <MultiSelect v-model="hcSubdomainsSelected" :options="hcSubdomains" placeholder="Select Subdomains" :maxSelectedLabels="3" class="w-full" />
        -->
      </div>
      <template #footer>
        <Button label="Cancel" severity="secondary" @click="visible = false" autofocus />
        <Button label="Save" :disabled="!saveEnabled" severity="primary" @click="onSave" autofocus />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
  import { useRbacStore } from '@/store/RBACStore';
  import { useBotsStore } from '@/store/BotsStore';
  import { useToast } from 'vue-toastification';
  import { ref, reactive, nextTick, computed } from 'vue';
  import InputText from 'primevue/inputtext';
  import { getUUID, pathPut } from '@enegelai/core';
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import Message from 'primevue/message';
  import MultiSelect from 'primevue/multiselect';
  import Dropdown from 'primevue/dropdown';
  import StdPropEditor from '@/components/Editors/StdPropEditor.vue';
  import StdItemMultiSelect from '@/components/Editors/StdItemMultiSelect.vue';

  const emit = defineEmits(['save']);

  const botsStore = useBotsStore();

  const visible = ref(false);

  const numberCopy = ref(reactive({}));

  const title = computed(() => {
    return `Edit Phone Number ${numberCopy.value?.id}`;
  });

  // Definition of editable category properties
  const propsDefs = {
    handoffNumber: { type: 'string', required: true, title: 'Handoff Number', description: 'Phone Number to send call on Hand Off', placeholder: 'Phone number in format NNN-NNN-NNNN' },
    /*
    voiceBotId: { type: 'string', required: true, label: 'Voice Bot', placeholder: 'Select Voice Bot assigned to this Phone Number' },
    */
  };

  const saveEnabled = computed(() => true);

  async function start(phoneNumber) {
    // Extract all category properties that we can edit in this dialog, set default values if not provided
    const phoneNumberEditableProps = {
      id: phoneNumber?.id || getUUID(),
      voiceBotId: phoneNumber?.voiceBotId || null,
      smsBotId: phoneNumber?.smsBotId || null,
      handoffNumber: phoneNumber?.handoffNumber || null,
    };

    // Make a deep reactive clone of the category object to avoid changing the original object
    numberCopy.value = reactive(JSON.parse(JSON.stringify(phoneNumberEditableProps)));

    visible.value = true;
  }

  function onSave() {
    emit('save', numberCopy.value);
    visible.value = false;
  }

  defineExpose({ start });
</script>
